import React, { useState, useEffect } from 'react';
import styles from './ItemPrice.module.scss';
import { useSharedCart } from '../../entrypoints/theme';

export default function ItemPrice({ cartKey }) {
  const { cartState } = useSharedCart();
  const [originalPrice, setOriginalPrice] = useState(0);
  const [discountedPrice, setDiscountedPrice] = useState(0);

  useEffect(() => {
    if (cartState && cartState.items) {
      const cartItem = cartState.items.find(item => item.key === cartKey && !item?.properties?.is_custom_option);
      if (cartItem) {
        setOriginalPrice(parseFloat(cartItem.properties.t * cartItem.quantity).toFixed(2));
        setDiscountedPrice(parseFloat(cartItem.main_item_price).toFixed(2));
      }
    }
  }, [cartState, cartKey]);

  return (
    <div className={styles.priceContainer}>
      <p className={styles.originalPrice}>${originalPrice}</p>
      {discountedPrice > 0 ? <p className={styles.discountedPrice}>${discountedPrice}</p> : "$0.00"}
    </div>
  );
}
